import alertService from "@/api/alert-api/weather.service";
import moment from "moment";
import "moment-duration-format";

const state = {
  alertsActive: [],
  detailAlerts: false,
  wetherAlertLoading: false,
  alertsActiveMenu: [],
  moutedDetailsAlert: false,
};

const mutations = {
  setAlertsActive(state, data) {
    state.alertsActive = data ? data : [];
  },
  setDetailsAlerts(state, data) {
    state.detailAlerts = data;
  },

  setAlertsActiveMenu(state, data) {
    state.alertsActiveMenu = data ? data : [];
  },

  setWetherAlertLoading(state, data) {
    state.wetherAlertLoading = data;
  },

  changeDetailsAlertsMounted(state, data) {
    state.moutedDetailsAlert = data;
  },
};

const actions = {
  async fetchAlertsActive({ commit }, data) {
    try {
      commit("setWetherAlertLoading", true);

      const finalDate = moment().utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const initialDate = moment()
        .utc()
        .add(-3, "hours")
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const response = await alertService.getAllAlerts(
        finalDate,
        initialDate
      );
      const responseActive = await alertService.getLast24hAlerts();

      const intensityLabel = (intensity) => {
        if (intensity == "T0") {
          return "SEM ALERTA";
        }
        if (intensity == "T1" || intensity == "T2") {
          return "FRACO";
        }
        if (intensity == "T3" || intensity == "T4") {
          return "MODERADO";
        }
        if (intensity == "T5" || intensity == "T6") {
          return "FORTE";
        }
        if (intensity == "T7" || intensity == "T8") {
          return "INTENSO";
        }
        if (intensity == "T9" || intensity == "T10") {
          return "EXTREMO";
        }
      };

      const typeWeatherAlerts = (type) => {
        if (type == "T0") {
          return {
            name: "T0",
            color: "#DCE775",
            borderColor: "#DCE775",
          };
        }
        if (type == "T1" || type == "T2") {
          return {
            name: "T1 e T2",
            color: "#CDDC39",
            borderColor: "#CDDC39",
          };
        }
        if (type == "T3" || type == "T4") {
          return {
            name: "T3 e T4",
            color: "#FDE047",
            borderColor: "#FDE047",
          };
        }
        if (type == "T5" || type == "T6") {
          return {
            name: "T5 e T6",
            color: "#FF9F00",
            borderColor: "#FF9F00",
          };
        }
        if (type == "T7" || type == "T8") {
          return {
            name: "T7 e T8",
            color: "#FB2E33",
            borderColor: "#FB2E33",
          };
        }
        if (type == "T9" || type == "T10") {
          return {
            name: "T9 e T10",
            color: "#D40D12",
            borderColor: "#D40D12",
          };
        }
      };

      const validity = (validity, color) => {
        if (validity === "até 1h hora") {
          return {
            pattern: {
              path: "M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11",
              width: 8,
              height: 8,
              color: color,
            },
          };
        }
        if (validity === "acima de 1h") {
          return {
            pattern: {
              path: "M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11",
              width: 8,
              height: 8,
              color: color,
              patternTransform: "rotate(45)",
            },
          };
        }
      };

      const weatherAlerts = [];

      const weatherAlertsActive = [];
      response.data.forEach((e) => {
        const findIndex = weatherAlerts.findIndex(
          (element) => element.companyZoneName == e.companyZoneName
        );
        const alertDuration = moment(e.alertEndForecast).diff(
          moment(e.alertStart)
        );

        const lastThreeHoursAlerts = moment().diff(moment(e.alertStart));

        const validityTest = moment
          .duration(alertDuration)
          .format("HH:mm")
          .split(":");

        const validityText =
          parseInt(validityTest[0]) <= 1 ? "até 1h hora" : "acima de 1h";

        if (findIndex == -1) {
          weatherAlerts.push({
            companyZoneName: e.companyZoneName,
            color: typeWeatherAlerts(e.eventName).color,
            borderColor: typeWeatherAlerts(e.eventName).borderColor,
            zoneId: e.zoneId,
            statusActive: e.alertEnd ? false : true,
            data: [
              {
                statusActive: e.alertEnd ? false : true,
                type: e.eventName,
                alertArea: e.alertArea,
                validityLabel: `${moment
                  .duration(alertDuration)
                  .format("HH[h]mm")}min`,
                name: moment(e.alertStart).format("HH:mm"),
                y: e.alertArea,
                intensityLabel: intensityLabel(e.eventName),
                color: validity(
                  validityText,
                  typeWeatherAlerts(e.eventName).color
                ),
                date: moment(e.alertStart).format("DD/MM/YYYY [às] HH:mm"),
                lastThreeHoursAlerts: lastThreeHoursAlerts,
                color2: typeWeatherAlerts(e.eventName).color,
              },
            ],
          });
        } else {
          weatherAlerts[findIndex].data.push({
            statusActive: e.alertEnd ? false : true,
            type: e.eventName,
            alertArea: e.alertArea,
            validityLabel: `${moment
              .duration(alertDuration)
              .format("HH[h]mm")}min`,
            name: moment(e.alertStart).format("HH:mm"),
            y: e.alertArea,
            intensityLabel: intensityLabel(e.eventName),
            color: validity(validityText, typeWeatherAlerts(e.eventName).color),
            date: moment(e.alertStart).format("DD/MM/YYYY [às] HH:mm"),
            color2: typeWeatherAlerts(e.eventName).color,
            lastThreeHoursAlerts: lastThreeHoursAlerts,
          });
        }
      });

      responseActive.data.forEach((e) => {
        const findIndex = weatherAlertsActive.findIndex(
          (element) => element.companyZoneName == e.companyZoneName
        );
        const alertDuration = moment(e.alertEndForecast).diff(
          moment(e.alertStart)
        );

        const lastThreeHoursAlerts = moment().diff(moment(e.alertStart));

        const validityTest = moment
          .duration(alertDuration)
          .format("HH:mm")
          .split(":");

        const validityText =
          parseInt(validityTest[0]) <= 1 ? "até 1h hora" : "acima de 1h";

        if (findIndex == -1) {
          weatherAlertsActive.push({
            companyZoneName: e.companyZoneName,
            color: typeWeatherAlerts(e.eventName).color,
            borderColor: typeWeatherAlerts(e.eventName).borderColor,
            zoneId: e.zoneId,

            data: [
              {
                statusActive: e.alertEnd ? false : true,
                type: e.eventName,
                alertArea: e.alertArea,
                validityLabel: `${moment
                  .duration(alertDuration)
                  .format("HH[h]mm")}min`,
                name: moment(e.alertStart).format("HH:mm"),
                y: e.alertArea,
                intensityLabel: intensityLabel(e.eventName),
                color: validity(
                  validityText,
                  typeWeatherAlerts(e.eventName).color
                ),
                date: moment(e.alertStart).format("DD/MM/YYYY [às] HH:mm"),
                lastThreeHoursAlerts: lastThreeHoursAlerts,
                color2: typeWeatherAlerts(e.eventName).color,
              },
            ],
          });
        } else {
          weatherAlertsActive[findIndex].data.push({
            statusActive: e.alertEnd ? false : true,
            type: e.eventName,
            alertArea: e.alertArea,
            validityLabel: `${moment
              .duration(alertDuration)
              .format("HH[h]mm")}min`,
            name: moment(e.alertStart).format("HH:mm"),
            y: e.alertArea,
            intensityLabel: intensityLabel(e.eventName),
            color: validity(validityText, typeWeatherAlerts(e.eventName).color),
            date: moment(e.alertStart).format("DD/MM/YYYY [às] HH:mm"),
            color2: typeWeatherAlerts(e.eventName).color,
            lastThreeHoursAlerts: lastThreeHoursAlerts,
          });
        }
      });

      const newArray = [];
      if (data.name == "agencias" || data.name == "municipios") {
        weatherAlerts.forEach((alert) => {
          newArray.push(alert);
        });
      }

      if (data.name == "regionais")
        weatherAlerts.forEach((alert) => {
          data.locations.forEach((e) => {
            if (e.id == alert.zoneId) {
              newArray.push(alert);
            }
          });
        });

      if (data.typeAlert == "menu") {
        commit("setAlertsActiveMenu", weatherAlertsActive);
      }

      if (data.typeAlert == "dashboard") {
        commit("setAlertsActive", newArray);
      }

      if (data.typeAlert == "allAlerts") {
        commit("setAlertsActiveMenu", weatherAlertsActive);
        commit("setAlertsActive", newArray);
      }
    } catch (error) {
      commit("setAlertsActive", []);
      commit("setAlertsActiveMenu", []);

    } finally {
      commit("setWetherAlertLoading", false);
    }
  },
};

const getters = {
  weatherAlerts1: (state) => state.alertsActive,
  detailsWeatherAlerts: (state) => state.detailAlerts,
  wetherAlertLoading: (state) => state.wetherAlertLoading,
  alertsActiveMenu: (state) => state.alertsActiveMenu,
  changedDetailsAlert: (state) => state.moutedDetailsAlert,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
